import { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';

// login routing
const AuthLogin = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
// const AuthRegister = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));
// const AuthForgotPassword = Loadable(lazy(() => import('views/pages/authentication/authentication3/ForgotPassword3')));
// const AuthResetPassword = Loadable(lazy(() => import('views/pages/authentication/authentication3/ResetPassword3')));
// const AuthCheckMail = Loadable(lazy(() => import('views/pages/authentication/authentication3/CheckMail3')));
const AuthCodeVerification = Loadable(lazy(() => import('views/pages/authentication/authentication3/CodeVerification3')));
const AuthMfaMethod = Loadable(lazy(() => import('views/pages/authentication/authentication3/SelectMfaMethod')));
const AuthOAuthCallback = Loadable(lazy(() => import('views/pages/authentication/oauth/AuthOAuthCallback')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  element: (
    <NavMotion>
      <GuestGuard>
        <MinimalLayout />
      </GuestGuard>
    </NavMotion>
  ),
  children: [
    {
      path: '/login',
      element: <AuthLogin />
    },
    {
      path: '/auth/mfa/method',
      element: <AuthMfaMethod />
    },
    {
      path: '/auth/mfa/verify',
      element: <AuthCodeVerification />
    },
    // {
    //   path: '/register',
    //   element: <AuthRegister />
    // },
    // {
    //   path: '/forgot',
    //   element: <AuthForgotPassword />
    // },
    // {
    //   path: '/reset-password',
    //   element: <AuthResetPassword />
    // },
    // {
    //   path: '/check-mail',
    //   element: <AuthCheckMail />
    // },
    {
      path: '/oauth/callback',
      element: <AuthOAuthCallback />
    }
  ]
};

export default LoginRoutes;
